// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__utFmFtuM2K{display:flex;flex-direction:row;width:100%;height:100%;overflow:hidden}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/analytics/analytics.view.module.scss"],"names":[],"mappings":"AAEA,kBACE,YAAA,CACA,kBAAA,CACA,UAAA,CACA,WAAA,CACA,eAAA","sourcesContent":["@import '@dixa/lib-shared-tokens/scss';\n\n.root {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__utFmFtuM2K`
};
export default ___CSS_LOADER_EXPORT___;
